import { useRef, useState, useLayoutEffect } from 'react';
import Popover from '@material-ui/core/Popover';

const EllipsisWithPopover = ({ children, className, style }) => {
  const textRef = useRef();
  const closeTimer = useRef();
  const [isTruncated, setIsTruncated] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useLayoutEffect(() => {
    const el = textRef.current;
    setIsTruncated(el && el.scrollWidth > el.clientWidth);
  }, [children, style]);

  const handleMouseEnter = (e) => {
    if (isTruncated) setAnchorEl(e.currentTarget);
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => {
      setAnchorEl(null);
    }, 100);
  };

  const handlePopoverEnter = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const handlePopoverLeave = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        ref={textRef}
        className={className}
        style={{
          ...style,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          cursor: isTruncated ? 'pointer' : 'default',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        tabIndex={0}
      >
        {children}
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverLeave}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          onMouseEnter: handlePopoverEnter,
          onMouseLeave: handlePopoverLeave,
          style: {
            width: textRef.current ? textRef.current.offsetWidth : undefined,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            padding: 8,
          }
        }}
        disableRestoreFocus
      >
        <div>{children}</div>
      </Popover>
    </>
  );
};

export default EllipsisWithPopover;
